import {
  PatientAssessmentControllerXApi,
  RescheduleAssessmentRequest,
} from "../../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../../utils/utils";

interface Params {
  assessmentId: string;
  body: RescheduleAssessmentRequest;
  xTENANTID?: string;
}

/**
 *
 * @author [Atish Bagate]
 */
export const useUpdateScheduledAssessment = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientAssessmentControllerXApi(getConfigObject()).rescheduleAssessment(
      params.assessmentId,
      params.body,
      params.xTENANTID
    )
  );
